// extracted by mini-css-extract-plugin
export default {"actionsMenu":"q2Rpsw","knob":"Po07qV","light":"RrKlAQ","menuContainer":"sFjYA6","opened":"bwSzOz","buttonMenu":"K_AsLi"};